<div style="margin: 24px">
    <p [innerHTML]="imprint | markdown"></p>
</div>
